import { masterAPI } from "@/lib/api/api";
import { MASTER_QUERY_KEY } from "@/lib/queryKeys";
import { UseQueryResult, useQuery } from "@tanstack/react-query";

type MasterData = {
  uuid: string;
  name: string;
};

type Response = {
  data: MasterData[];
};

export const useMasterData = (
  type: string,
  name?: string,
  parentUuids?: string,
  countryIsoCode?: string,
): UseQueryResult<Response, Error> => {
  return useQuery({
    queryKey: [MASTER_QUERY_KEY, type, name, parentUuids, countryIsoCode],
    queryFn: () => {
      if (!type) {
        return Promise.reject(new Error("Type must be provided"));
      }
      return masterAPI<Response>(type, name, parentUuids, countryIsoCode);
    },
    enabled: !!type, // Only enable the query if type is provided
  });
};
